import styled from 'styled-components'
import YoutubePlayer from '../../components/YoutubePlayer'
import KalaBackground from '../../images/background.jpg'

const VideoContainer = styled.div`
	width: 100vh;
	max-width: 100%;
`

const Title = styled.h2`
	margin: 0;
	z-index: 10;
`

/**
 * Using a container-filling absolutely positionned block container to
 * be able to change the opacity and improve readability here.
 */
const Background = styled.div`
	height: 100%;
	width: 100%;
	position: absolute;

	background: url(${KalaBackground}) no-repeat center center;
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	opacity: 0.5;
	box-shadow: inset 0 -50px 50px 20px rgb(248, 249, 243);
	z-index: 0;
`

export default function Home() {
	return (
		<>
			<Background />
			<VideoContainer
				style={{
					margin: 0,
					padding: '0 20px',
				}}
			>
				<YoutubePlayer
					src={
						'https://www.youtube-nocookie.com/embed/videoseries?list=PLIJ8-QniRgXvE24WuGAjt2oVR2kExyfc3'
					}
				/>
			</VideoContainer>
		</>
	)
}
